<template>
  <div v-if="!isMobile" class="d-flex">
    <a
      class="nav-notification position-relative"
      data-toggle="dropdown"
      href="#"
      :aria-label="notificationAriaLabel"
      aria-haspopup="false"
      aria-expanded="false"
      @click="loadNotifications"
    >
      <div class="notification-account d-flex align-items-center">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0492 3.54096C15.0984 3.54096 17.6557 5.99998 17.6557 9.14752V15.5409H6.44262V9.14752C6.44262 5.99998 8.90164 3.54096 12.0492 3.54096ZM19.1311 9.14752V15.5409H21V17.0163H19.1311V17.0164H4.96721V17.0163H3V15.5409H4.96721V9.14752C4.96721 5.21309 8.11475 2.06555 12.0492 2.06555C15.8852 2.06555 19.0328 5.21309 19.1311 9.14752ZM13.623 20.3606C13.623 21.2298 12.9184 21.9344 12.0493 21.9344C11.1801 21.9344 10.4755 21.2298 10.4755 20.3606C10.4755 19.4915 11.1801 18.7869 12.0493 18.7869C12.9184 18.7869 13.623 19.4915 13.623 20.3606Z" fill="#595E6B"/>
        </svg>
        <span
          v-if="hasUnseenNotifications"
          class="notification-badge-dot"
          aria-hidden="true"
        ></span>
      </div>
    </a>
    <div class="dropdown-menu dropdown-notification topbar-dropdown" :class="isMobile ? 'dropdown-menu' : 'dropdown-menu-right'">
      <div v-if="loading" style="padding: 20px; text-align: center">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only"></span>
        </div>
      </div>
      <div v-else>
        <template v-if="notifications.length">
          <div class="text-right delete-all-block">
            <span @click="deleteNotifications" class="text-primary"><u>Ջնջել բոլորը</u></span>
          </div>
          <div class="notification-blocks overflow-auto little-scroll">
            <div v-for="notification in notifications"
                 @click="goToNotification(notification)"
                 :key="notification.id"
                 :class="notification.read_at == null && 'unread-notification-item'"
                 class="dropdown-item notification-item"
            >
              <div class="notification-title row justify-content-between m-0 p-0">
                <div class="col p-0 notification-name">
                  {{notification.data.subject}}
                </div>
                <div class="col-auto p-0 notification-time">{{toOpeningTime(notification.created_at)}}</div>
              </div>
              <div class="notification-content row justify-content-between m-0 p-0">
                <div class="col p-0  text-truncate-container">
                          <span v-if="notification.data.customer" class="w-100">
                            Պատվիրատու՝ {{notification.data.customer}}
                          </span>
                </div>
                <div class="col-auto p-0 d-flex align-items-center">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.4828 10.595L9.51724 5.77777L8 7.24969L12.9655 12.0669L8 16.7503L9.51724 18.2222L14.4828 13.5388L16 12.0669L14.4828 10.595Z" fill="#006BE6"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="text-center delete-all-block">
            <span class="no-notification">Ծանուցումներ չկան</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import isMobile from "@/mixins/isMobileView";

export default {
  name: 'Notifications',
  mixins: [isMobile],
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    menuNotifications() {
      return this.$store.getters["user/menuNotifications"];
    },
    hasUnseenNotifications() {
      return this.unseenNotificationsTotal > 0
    },
    notificationAriaLabel() {
      if (this.hasUnseenNotifications) {
        return `Չընթերցված ծանուցումներ (${this.unseenNotificationsTotal})`
      }

      return 'Ծանուցումներ'
    },
    notifications() {
      return this.$store.getters["user/notifications"];
    },
    unseenNotificationsTotal() {
      const notifications = this.menuNotifications || {}
      const total = Number(notifications.unseen_notifications)
      return Number.isFinite(total) ? total : 0
    },
  },
  methods: {
    async loadNotifications() {
      this.loading = true
      this.$store.dispatch('user/getNotifications').then(response => {
        this.loading = false
      })
    },
    toOpeningTime(openingDateTime){
      const date1 = new Date(openingDateTime);
      const date2 = new Date();
      const diffTime = Math.abs(date2 - date1);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if(diffDays <= 1){
        this.$moment(openingDateTime, 'YYYY-MM-DD hh:mm:ss').startOf('hour').fromNow()
        this.$moment.locale('hy-am');
        let openingText = this.$moment(openingDateTime, 'YYYY-MM-DD hh:mm:ss').startOf('minute').fromNow()
        if(openingText  === 'օր հետո'){
          openingText = '1 օր հետո';
        }
        return openingText;
      } else {
        return openingDateTime;
      }
    },
    goToNotification(notification){
      console.log(notification.data.type)
      switch (notification.data.type) {
        case "tender_edited":
        case 'tender_created':
          this.$router.push(`/participant/tenders/?id=${notification.data.tender_id}`);
          break;
        case 'contract_order':
          this.$router.push(`/participant/contract-management/orders/active`);
          break;
        case 'contract_request':
          this.$router.push(`/participant/contract-management/requests`);
          break;

        default:
          break;
      }
      this.$client.post(`user/notifications/read/${notification.id}`).then(({data}) => {
        if(data.status){
          this.$store.dispatch('user/getMenuNotifications')
          this.$store.dispatch('user/getNotifications')
        }
      })
    },
    deleteNotifications(){
      this.$client.post(`user/notifications/delete-all`).then((value) => {
        this.$store.dispatch('user/getMenuNotifications')
        this.$store.dispatch('user/getNotifications')
      })
    },
  }
}
</script>
